const Z_BELOW_BASE = 0;
const Z_BASE = 1;
const Z_ABOVE_BASE = 2;
const Z_BELOW_MIDDLE = 3;
const Z_MIDDLE = 4;
const Z_ABOVE_MIDDLE = 5;
const Z_BELOW_TOP = 6;
const Z_TOP = 7;

module.exports = {
  Z_BELOW_BASE,
  Z_BASE,
  Z_ABOVE_BASE,
  Z_BELOW_MIDDLE,
  Z_MIDDLE,
  Z_ABOVE_MIDDLE,
  Z_BELOW_TOP,
  Z_TOP
};
